// src/constants/formOptions.js
export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' }
];

export const YEAR_OPTIONS = [
  { value: '1', label: 'Freshman' },
  { value: '2', label: 'Sophomore' },
  { value: '3', label: 'Junior' },
  { value: '4', label: 'Senior' },
  { value: '5', label: 'Graduate Student' },
  { value: '6', label: 'Alumni' },
];

export const SEM_OPTIONS = [
  { value: '1', label: 'Fall' },
  { value: '2', label: 'Spring' },
  { value: '3', label: 'Summer' },

];

export const MARITAL_STATUS_OPTIONS = [
  { value: 'single', label: 'Single' },
  { value: 'married', label: 'Married' },
  { value: 'divorced', label: 'Divorced' },
  { value: 'widowed', label: 'Widowed' },
];

export const MAJORS_OPTIONS = [
  // Undergraduate Programs
  { value: 'Bachelor of Science in Nursing', label: 'Bachelor of Science in Nursing' },
  { value: 'Bachelor of Science in Artificial Intelligence (AI) & Robotics', label: 'Bachelor of Science in Artificial Intelligence (AI) & Robotics' },
  { value: 'Bachelor of Science in Accounting', label: 'Bachelor of Science in Accounting' },
  { value: 'Bachelor of Science in Finance', label: 'Bachelor of Science in Finance' },
  { value: 'Bachelor of Science in Hotel & Restaurant Management', label: 'Bachelor of Science in Hotel & Restaurant Management' },
  { value: 'Bachelor of Science in International Business Administration', label: 'Bachelor of Science in International Business Administration' },
  { value: 'Bachelor of Science in Data Science & Analytics', label: 'Bachelor of Science in Data Science & Analytics' },
  { value: 'Bachelor of Science in Software Engineering', label: 'Bachelor of Science in Software Engineering' },
  { value: 'Bachelor of Science in Information Systems & Technology', label: 'Bachelor of Science in Information Systems & Technology' },
  { value: 'Bachelor of Science in Applied Computer Technology', label: 'Bachelor of Science in Applied Computer Technology' },
  { value: 'Bachelor of Arts in Journalism', label: 'Bachelor of Arts in Journalism' },
  { value: 'Bachelor of Arts in Film Production & Directing', label: 'Bachelor of Arts in Film Production & Directing' },
  { value: 'Bachelor of Arts in Animation', label: 'Bachelor of Arts in Animation' },
  { value: 'Bachelor of Arts in International Relations', label: 'Bachelor of Arts in International Relations' },
  { value: 'Bachelor of Arts in Psychology', label: 'Bachelor of Arts in Psychology' },
  { value: 'Bachelor of Arts in Criminal Justice Studies', label: 'Bachelor of Arts in Criminal Justice Studies' },
  { value: 'Bachelor of Pharmacy', label: 'Bachelor of Pharmacy' },

  // Graduate Programs
  { value: 'Master of Arts in Clinical Psychology', label: 'Master of Arts in Clinical Psychology' },
  { value: 'Master of Arts in Communication Studies', label: 'Master of Arts in Communication Studies' },
  { value: 'Master of Arts in Counseling Psychology', label: 'Master of Arts in Counseling Psychology' },
  { value: 'Master of Arts in International Relations', label: 'Master of Arts in International Relations' },
  { value: 'Master of Arts in Marriage & Family Therapy', label: 'Master of Arts in Marriage & Family Therapy' },
  { value: 'Master of Arts in Criminal & Transitional Justice', label: 'Master of Arts in Criminal & Transitional Justice' },
  { value: 'Master of Business Administration', label: 'Master of Business Administration' },
  { value: 'Master of Business Administration – Global Business Management', label: 'Master of Business Administration – Global Business Management' },
  { value: 'Master of Business Administration – Health Leadership & Management', label: 'Master of Business Administration – Health Leadership & Management' },
  { value: 'Master of Science in Data Science & Analytics', label: 'Master of Science in Data Science & Analytics' },
  { value: 'Master of Science in Clinical Pharmacology & Therapeutics', label: 'Master of Science in Clinical Pharmacology & Therapeutics' },
  { value: 'Master of Science in Management & Organizational Development', label: 'Master of Science in Management & Organizational Development' },
  { value: 'Master of Science in Information Systems & Technology', label: 'Master of Science in Information Systems & Technology' },
  { value: 'Master of Science in Information Security', label: 'Master of Science in Information Security' },
  { value: 'Master of Science in Global Banking & Finance', label: 'Master of Science in Global Banking & Finance' },

  // Doctoral Programs
  { value: 'Doctor of Business Administration (DBA)', label: 'Doctor of Business Administration (DBA)' },
  { value: 'Doctor of Psychology (PsyD), Clinical Psychology', label: 'Doctor of Psychology (PsyD), Clinical Psychology' },
  { value: 'Doctor of Philosophy in International Relations', label: 'Doctor of Philosophy in International Relations' },
  { value: 'Doctor of Philosophy in Information Systems & Technology', label: 'Doctor of Philosophy in Information Systems & Technology' },
].sort((a, b) => a.label.localeCompare(b.label));

export const getDayOptions = () => {
  return Array.from({ length: 31 }, (_, i) => ({
    value: (i + 1).toString().padStart(2, '0'),
    label: (i + 1).toString()
  }));
};

export const getMonthOptions = () => {
  return [
    { value: '01', label: 'Jan' },
    { value: '02', label: 'Feb' },
    { value: '03', label: 'Mar' },
    { value: '04', label: 'Apr' },
    { value: '05', label: 'May' },
    { value: '06', label: 'Jun' },
    { value: '07', label: 'Jul' },
    { value: '08', label: 'Aug' },
    { value: '09', label: 'Sep' },
    { value: '10', label: 'Oct' },
    { value: '11', label: 'Nov' },
    { value: '12', label: 'Dec' }
  ];
};

export const getYearOptionsRange = (startYear, endYear) => {
  const years = [];
  for (let i = endYear; i >= startYear; i--) {
    years.push({ value: i.toString(), label: i.toString() });
  }
  return years;
};
